import TimeHelper from '@/classes/time_helper.js'
import Settings from '@/classes/settings.js'
import moment from 'moment'

// Templates to be used to fill the data 
// 	The element of {{?textthatwillbereplaced}} will be itirate and replaced be providet text
const templateManualPaymentReminder =  
`{{?getPaymentReminder}} מצורפת תזכורת בנוגע לדרישת תשלום.

לנוחיותך, מצורפת מטה הדרישה הפתוחה ונודה מאוד לעזרתך בקידום הטיפול.
{{?getFuturePaymentReminder}}
{{?getBankTransferDetails}}

לקבלת כל מסמך נוסף מאיתנו או מענה לכל שאלה ניתן לפנות במייל חוזר או ישירות בנייד: 050-6399920

{{?bestRegards}}
{{?getFooterDetails}}
`

class EmailTemplateHelper {

	constructor(offer){
		let settings = new Settings()
		this.time_helper = new TimeHelper()
		this.offer = offer
		this.env = settings.getEnv(offer.env)
		this.finance_email = settings.get({ path: 'finance_email', env: this.env.toLowerCase() })
		this.website = settings.get({ path: 'website', env: this.env.toLowerCase() })
		this.phone_number = settings.get({ path: 'phone_number', env: this.env.toLowerCase() })
		this.maturityDate = moment(offer.start_date).add(offer.maturation_days, 'd')
		this.maturityDateFormat = moment(offer.start_date).add(offer.maturation_days, 'd').format('DD/MM/YYYY')
	}

	createFromTemplate(template, ...args) {
		if (args.length !== (template.match(/{{\?[a-zA-Z]*}}/g) || []).length) {
			throw 'Function createFromTemplate need to recieve mathing numbers of argumnets to template occurrence of {{?}}'
		}
		let count = -1
		return template.replace(/{{\?[a-zA-Z]*}}/g, () => args[++count])
	}
	
	getFooterDetails(){
		return `מחלקת כספים\n${this.env}\n\nטלפון: ${this.phone_number}\nאימייל: <a href="mailto:${this.finance_email}">${this.finance_email}</a>\nבקרו באתר שלנו: <a href="${this.website}">${this.website}</a>\n\n${this.getSignature()}`
	}

	getSignature() {
		if(this.env == 'Suitup'){
			return `^^מגייסים צוות לתחום הכספים והאדמיניסטרציה ?^^\n\n<u>התפקידים הפיננסיים והאדמיניסטרטיביים אליהם אנו מגייסים:</u>\n*רואי חשבון , חשבים ועוזרי חשב, מנהלי חשבונות, יועצי מס, כלכלנים , חשבי שכר , סמנכ"לי כספים , יועצים פיננסים ואנליסטים.\n* מועמדים לתחום האדמיניסטרציה והשיווק הכולל: מזכירות , עוזרת אישית , מנהלי שיווק , פיתוח עסקי, מנהלי מותג , ומנהלים בתחום הרכש.\n\n^^צרו איתנו קשר!^^\nבאתר - https://www.piola.co.il\nאימייל - office@piola.co.il`
		}
		if(this.env == 'Rebase'){
			return `^^מגייסים צוות משפטי ועורכי דין ?^^\n\n<u>התפקידים המשפטיים אליהם אנו מגייסים:</u>\n* יעוץ משפטי -  Legal Counsel, General Counsel (GC), Head of Legal\n* מזכירות חברה (ציבורית ופרטית)\n* GDPR והגנת הפרטיות - DPO, Privacy Director\n* ציות -  Compliance\n* אכיפה - Enforcement Officer\n\n^^צרו איתנו קשר!^^\nבאתר - https://www.suitup.co.il\nאימייל - office@suitup.io\n\n^^מגייסים צוות לתחום הכספים והאדמיניסטרציה ?^^\n\n<u>התפקידים הפיננסיים והאדמינסטרטיביים אליהם אנו מגייסים: </u>\n*רואי חשבון , חשבים ועוזרי חשב, מנהלי חשבונות, יועצי מס, כלכלנים , חשבי שכר , סמנכ"לי כספים , יועצים פיננסים ואנליסטים.\n* מועמדים לתחום האדמיניסטרציה והשיווק הכולל: מזכירות , עוזרת אישית , מנהלי שיווק , פיתוח עסקי, מנהלי מותג , ומנהלים בתחום הרכש.\n\n^^צרו איתנו קשר!^^\nבאתר - https://www.piola.co.il\nאימייל - office@piola.co.il`
		}
		if(this.env == 'Piola'){
			return `^^מגייסים צוות משפטי ועורכי דין ?^^\n\n<u>התפקידים המשפטיים אליהם אנו מגייסים:</u>\n* יעוץ משפטי -  Legal Counsel, General Counsel (GC), Head of Legal\n* מזכירות חברה (ציבורית ופרטית)\n* GDPR והגנת הפרטיות - DPO, Privacy Director\n* ציות -  Compliance\n* אכיפה - Enforcement Officer\n\n^^צרו איתנו קשר!^^\nבאתר - https://www.suitup.co.il\nאימייל - office@suitup.io\n\n^^מגייסים צוות לתחום הכספים והאדמיניסטרציה ?^^\n\n<u>התפקידים הפיננסיים והאדמינסטרטיביים אליהם אנו מגייסים: </u>\n*רואי חשבון , חשבים ועוזרי חשב, מנהלי חשבונות, יועצי מס, כלכלנים , חשבי שכר , סמנכ"לי כספים , יועצים פיננסים ואנליסטים.\n* מועמדים לתחום האדמיניסטרציה והשיווק הכולל: מזכירות , עוזרת אישית , מנהלי שיווק , פיתוח עסקי, מנהלי מותג , ומנהלים בתחום הרכש.\n\n^^צרו איתנו קשר!^^\nבאתר - https://www.piola.co.il\nאימייל - office@piola.co.il`
		}
	}

	bestRegards(){
		return 'בברכה,'
	}

	getBankTransferDetails(){
		return `נשמח אם תוכלו להעביר את התשלום במועדו לחשבון הבנק שלנו:\nמוטב:\nסמארט מאטצ׳ינג בע״מ, בנק הפועלים (מספר 12), סניף 780, חשבון 410955`
	}

	getRecipientNamePreference(){
		return `חשבונית המס תופק עבור: ${this.offer.company.name}\n\n^^האם תרצו לשנות שם זה?^^\n`
	}

	getNamedGreetings () {
		return `שלום רב,\n^^ברכות על גיוס מוצלח של ${this.offer.applicant_name}!^^`
	}

	getFuturePaymentReminder() {
		const future = this.maturityDate.isAfter(new Date())
		return future ? `\nתזכורת זו נשלחת אליכם במועד זה למען הנוחות, ויש להעביר את התשלום בגינה עד ליום ${this.maturityDateFormat}.\n` : ''
	}

	getFuturePaymentDemand() {
		const future = this.maturityDate.isAfter(new Date())
		return future ? `\nדרישה זו נשלחת אליכם במועד זה למען הנוחות, ויש להעביר את התשלום בגינה עד ליום ${this.maturityDateFormat}.\n` : ''
	}

	getPaymentReminder() {
		const paymentRequestDate = moment(this.offer.payment_request_date).format('DD/MM/YYYY')
		return (this.offer.payment_request_date != undefined && this.offer.payment_request_date.length > 0 ? `בהמשך לדרישת התשלום שהועברה אליכם בתאריך ${paymentRequestDate}` : '')
	}

	getDocumentTypes(){
		return {
			payment_request: {
				greetings: this.getNamedGreetings(),
				display_name: 'דרישת תשלום',
				title: `${this.env}: ${this.offer.company.name} - ${this.offer.applicant_name} - ברכות על הגיוס ודרישת תשלום`,
				manual_text: `מצ״ב דרישת תשלום עבור ההשמה.${this.getFuturePaymentDemand()}\n${this.getBankTransferDetails()}\n\n\n${this.getRecipientNamePreference()}\n${this.bestRegards()}\n${this.getFooterDetails()}`,
				anonymous: {
					title: `${this.env}: ${this.offer.company.name} - ברכות על הגיוס ודרישת תשלום`,
					manual_text: `מצ"ב דרישת תשלום.\nנא להעביר את התשלום במועד הקבוע לפי ההסכם.\n\n${this.getBankTransferDetails()}\n\n\n${this.getRecipientNamePreference()}\n${this.bestRegards()}\n${this.getFooterDetails()}`
				}
			},
			payment_reminder: {
				display_name: 'תזכורת לתשלום',
				title: `${this.env}: ${this.offer.company.name} - ${this.offer.applicant_name} - תזכורת לתשלום`,
				manual_text:  this.createFromTemplate(templateManualPaymentReminder, this.getPaymentReminder(), this.getFuturePaymentReminder(), this.getBankTransferDetails(), this.bestRegards(), this.getFooterDetails()),
				anonymous: {
					title: `${this.env}: ${this.offer.company.name} - תזכורת לתשלום`
				}
			},
			invoice_and_receipt: {
				display_name: 'חשבונית מס קבלה',
				title: `${this.env}: ${this.offer.company.name} - ${this.offer.applicant_name} - חשבונית מס קבלה`,
				manual_text: `אנו מודים לכם על העברת התשלום.\nמצ“ב חשבונית מס / קבלה.\n\n${this.bestRegards()}\n${this.getFooterDetails()}`,	
				anonymous: {
					title: `${this.env}: ${this.offer.company.name} - חשבונית מס קבלה`,
					manual_text: `אנו מודים לכם על העברת התשלום.\nמצ“ב חשבונית מס / קבלה.\n\n${this.bestRegards()}\n${this.getFooterDetails()}`		
				}
			},
			invoice: {
				display_name: 'חשבונית מס',
				title: `${this.env}: ${this.offer.company.name} - ${this.offer.applicant_name} - חשבונית מס`,
				manual_text: `מצ“ב חשבונית מס.\n\n${this.bestRegards()}\n${this.getFooterDetails()}`,	
				anonymous: {
					title: `${this.env}: ${this.offer.company.name} - חשבונית מס`,
					manual_text: `מצ“ב חשבונית מס.\n\n${this.bestRegards()}\n${this.getFooterDetails()}`		
				}
			},
			receipt: {
				display_name: 'קבלה',
				title: `${this.env}: ${this.offer.company.name} - ${this.offer.applicant_name} - קבלה`,
				manual_text: `אנו מודים לכם על העברת התשלום.\nמצ“ב קבלה.\n\n${this.bestRegards()}\n${this.getFooterDetails()}`,	
				anonymous: {
					title: `${this.env}: ${this.offer.company.name} - קבלה`,
					manual_text: `אנו מודים לכם על העברת התשלום.\nמצ“ב קבלה.\n\n${this.bestRegards()}\n${this.getFooterDetails()}`		
				}
			},		
		}
	}

}

export default EmailTemplateHelper